import React, { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Card, Button, List, Tooltip, Typography } from 'antd'
import { ArrowRightOutlined, SyncOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { getWorkspaces } from '../../Actions/workspaceApi'

const { Text } = Typography

function WorkspacesWidget() {
  const [posts, setPosts] = useState([])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [page, setPage] = useState(0)
  const { isLoading, refetch, data } = useQuery({
    queryKey: ['getWorkspaces', page],
    queryFn: () => getWorkspaces(page),
    onError: (error) => {
      console.log(error)
    },
  })

  useEffect(() => {
    if (data) {
      setPosts(data.content)
    }
  }, [data])

  return (
    <Card
      title={
        <Link to="/workspace">
          워크스페이스 <ArrowRightOutlined />
        </Link>
      }
      headStyle={{ paddingInline: '16px' }}
      bodyStyle={{ padding: 0 }}
      loading={isLoading}
      extra={
        <Tooltip title="새로고침">
          <Button shape="circle" size="small" onClick={refetch} icon={<SyncOutlined />} loading={isLoading} />
        </Tooltip>
      }
    >
      <List itemLayout="vertical" size="small">
        {posts &&
          posts
            .map((workspace) => (
              <List.Item
                key={`${workspace.createdAt}-${Math.floor(Math.random() * 100)}${1}`}
                extra={<Text type="secondary">{workspace.createdAt.slice(0, 10)}</Text>}
              >
                {workspace.name}
              </List.Item>
            ))
            .slice(0, 5)}
      </List>
    </Card>
  )
}
export default WorkspacesWidget
